import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';

import PageNotFoundImg from 'assets/page-not-found.svg';
import TrailSafeLogo from 'assets/TrailSafe_TempLogo.png';

import MLButton from '../../components/common/Button/Button';
import { ROUTES } from 'constants/RoutePaths';

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="flex justify-between gap-4 items-center px-[32px] py-[10px] h-[149px] border-b border-[var(--Grey-30)] ">
        <img className="w-[149px]" alt="TrailSafe Logo" src={TrailSafeLogo} />
      </div>

      <div className="container m-auto h-[calc(100%_-_81px)]">
        {/* <img className="w-[149px]" alt="TrailSafe Logo" src={TrailSafeLogo} /> */}
        <div className="flex justify-center items-center gap-4 p-5 h-full">
          <div className="flex flex-col w-2/4">
            <Typography variant="h1" fontWeight={700} className="!mb-4">
              Sorry!
            </Typography>
            <Typography variant="h4" fontWeight={600} className="!mb-1">
              We can't seem to find the page you're looking for.
            </Typography>
            <Typography
              variant="h4"
              fontWeight={400}
              className="!mb-5 text-[var(--Grey-80)]"
            >
              Please check that the web site address is entered correctly or go
              to our home page, and use the menus to find what you need.
            </Typography>
            <MLButton
              classList="w-fit"
              btnText="Back to home"
              onClickFunc={() => {
                navigate(`/${ROUTES.HOME}`);
              }}
            />
          </div>
          <div className="w-2/4">
            <img
              className="max-h-[600px] w-full h-full"
              src={PageNotFoundImg}
              alt="Page not found"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PageNotFound;
